module.exports = __webpack_public_path__ + "img/2.1719ae94.jpg";